define('BrandsPage.List.Details.View', [
    'SCView',
    'BrandsPage.List.Helper',
    'brandspage_details.tpl'
], function (
    SCViewModule,
    BrandsPageListHelper,
    brandspage_details_tpl
) {
    'use strict';

    var SCView = SCViewModule.SCView;

    function BrandsPageListDetailsView (options) {
        SCView.call(this, options);

        this.model = options.model;

        this.template = brandspage_details_tpl;
    }

    BrandsPageListDetailsView.prototype = Object.create(SCView.prototype);
    BrandsPageListDetailsView.prototype.constructor = BrandsPageListDetailsView;

    BrandsPageListDetailsView.prototype.getContext = function () {
        
        var brandname = this.model.get('brand');
        var brandimage = this.model.get('image');
        var brandlink = this.model.get('link');
        var sortorder = this.model.get('sortorder');

        return {
            model: this.model,
            brandname: brandname,
            brandimage: brandimage,
            brandlink: brandlink,
            sortorder: sortorder
        }
    }

    return BrandsPageListDetailsView
})
